export default "__VITE_ASSET__C_b$rsqh__"